import React, { useState, useEffect } from "react";

import {
    Button,
    colors,
    Container,
    Grid,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../../../help/Api";

import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import RestInfoTable from "./RestInfoTable";
import RestInfoForm from "./RestInfoForm";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function RestInfo(props) {
    const {res_id, branch, fromInv, proc_id,} = props;
    const { t } = useTranslation(["forms", "translation"]);
    const [rptParams, setRptParams] = React.useState({
        branch: branch,
        proc_id:proc_id,
    });
    const { data, fetching, fetchURL } = useFetchURL({
        ...{
            url:
                uri +
                `AccountReports/GetRestInfo?res_id=${res_id}
        &&branch=${branch}
        &&fromInv=${fromInv}
        &&proc_id=${proc_id}`,
            dependencyArray: [rptParams],
        },
    });


    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();

    const his = useHistory();

    return (
        <div className={classes.root}>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <br />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                    }}
                >
                    <Grid container justifyContent="center" spacing={1}>
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <RestInfoForm
                                {...{
                                    data: data?.Rest ? data.Rest : [],
                                }}
                            />
                        </Grid>

                        <Grid item container justifyContent="center" xs={12}>
                            <BeatLoader loading={fetching} color={colors.green[300]} />
                            {!fetching && (
                                <RestInfoTable
                                    {...{
                                        data: data?.RestSub ? data.RestSub : [],
                                    }}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Container>
            </Typography>
        </div>

    );
}
